import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";

import * as firebase from "firebase";

import { FirestoreService } from "./services/Firestore/firestore.service";
import { AuthService } from "./services/AuthService/auth.service";
import { MatDialog } from "@angular/material";
import { LoginModalComponent } from "./components/login-modal/login-modal.component";
import { FirebaseStorageService } from "./services/FirebaseStorage/firebase-storage.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit {
  title = "Dashboard";
  login: boolean = true;

  constructor(
    private router: Router,
    private firestoreService: FirestoreService,
    public storageService: FirebaseStorageService,
    private authService: AuthService,
    private dialog: MatDialog
  ) {
    this.checkAuth();
    this.initialiseGenres();

    router.events.subscribe((val: NavigationEnd) => {
      const elements = document.getElementsByClassName("active");

      Array.prototype.forEach.call(elements, function (element) {
        element.classList.remove("active");
      });

      switch (val.urlAfterRedirects) {
        case "/dashboard":
          const dashboardMenuItem = document.getElementById(
            "dashboardMenuItem"
          );
          dashboardMenuItem.classList.add("active");
          this.title = "Dashboard";
          break;

        case "/artists":
          const artistsMenuItem = document.getElementById("artistsMenuItem");
          artistsMenuItem.classList.add("active");
          this.title = "Artists";
          break;

        case "/albums":
          const albumsMenuItem = document.getElementById("albumsMenuItem");
          albumsMenuItem.classList.add("active");
          this.title = "Albums";
          break;

        case "/songs":
          const songsMenuItem = document.getElementById("songsMenuItem");
          songsMenuItem.classList.add("active");
          this.title = "Songs";
          break;

        case "/genres":
          const genresMenuItem = document.getElementById("genresMenuItem");
          genresMenuItem.classList.add("active");
          this.title = "Genres & Moods";
          break;

        case "/playlists":
          const playlistsMenuItem = document.getElementById(
            "playlistsMenuItem"
          );
          playlistsMenuItem.classList.add("active");
          this.title = "Playlists";
          break;

        case "/users":
          const userssMenuItem = document.getElementById(
            "userssMenuItem"
          );
          userssMenuItem.classList.add("active");
          this.title = "Users";
          break;

        case "/playlistGroups":
          const playlistGroupsMenuItem = document.getElementById(
            "playlistGroupsMenuItem"
          );
          playlistGroupsMenuItem.classList.add("active");
          this.title = "Playlist Groups";
          break;

        case "/privacy":
          const privacy = document.getElementById(
            "privacy"
          );
          privacy.classList.add("active");
          this.title = "Privacy Policy";
          break;
        case "/terms":
          const terms = document.getElementById(
            "terms"
          );
          terms.classList.add("active");
          this.title = "Change Terms and Conditions";
          break;
      }
    });
  }

  ngOnInit() {

    this.checkAuth();
  }

  checkAuth() {
    this.authService.afAuth.authState.subscribe((user: firebase.User) => {
      console.log('login', this.login);
      if (!user) {
        this.router.navigateByUrl('/login');
        this.login = false;
        // const dialogRef = this.dialog.open(LoginModalComponent, {});

        // dialogRef.afterClosed().subscribe(result => {
        // if (this.authService.afAuth.auth.currentUser === null) {
        //   this.checkAuth();
        // }
        // });
      }
      else {
        this.login = true;
        this.router.navigateByUrl('/');
        // this.dialog.closeAll();
      }
    });
  }

  initialiseGenres() {
    this.firestoreService.getGenres().then((result: any) => {
      if (result.genres.length <= 0) {
        this.firestoreService.initialiseGenres();
      }
    });
  }

  signOut() {
    setTimeout(() => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.router.navigate(["/login"]);
        });
    }, 500);
  }
}
